/**
* Based on Github dark dimmed
*/

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #539bf5;
	--pce-bg: #22272e;
	--pce-widget-border: #444;
	--pce-widget-bg: #22272e;
	--pce-widget-color: #adbac7;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #8a99a8;
	--pce-widget-bg-input: #2d333b;
	--pce-widget-bg-hover: #5a5d5e4f;
	--pce-widget-bg-active: #1f6feb66;
	--pce-widget-focus: #007acc;
	--pce-search-match: #eac55f80;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #636e7b1a;
	--pce-selection-match: #57ab5a40;
	--pce-line-number: #636e7b;
	--pce-scrollbar: 210, 10%, 35%;
	--pce-bg-fold: #768390;
	--pce-guide-indent: #adbac71f;
	--pce-ac-icon-class: #e0823d;
	--pce-ac-icon-enum: #e0823d;
	--pce-ac-icon-event: #636e7b;
	--pce-ac-icon-function: #b083f0;
	--pce-ac-icon-interface: #e0823d;
	--pce-ac-icon-keyword: #f47067;
	--pce-ac-icon-namespace: #f47067;
	--pce-ac-icon-parameter: #6cb6ff;
	--pce-ac-icon-property: #e0823d;
	--pce-ac-icon-snippet: #539bf5;
	--pce-ac-icon-text: #6cb6ff;
	--pce-ac-icon-unit: #539bf5;
	--pce-ac-icon-variable: #e0823d;
	--pce-selection: #264f78;
	color-scheme: dark;
}

.pce-match {
	--pce-search-match: #888a6c;
}

.active-line {
	--pce-line-number: #adbac7;
}

.active-indent {
	--pce-guide-indent: #adbac73d;
}

[class*="language-"],
.token.url > .operator,
.token.punctuation,
.token.attr-equals,
.token.code.keyword {
	color: #adbac7;
}

.token.class-name,
.token.maybe-class-name,
.token.atrule,
.token.variable,
.language-css .url,
.token.parameter,
.token.list {
	color: #f69d50;
}

.token.atrule .rule,
.token.unit,
.token.selector .combinator,
.token.operator,
.token.deleted,
.token.entity,
.token.regex-flags,
.token.token.anchor,
.token.number.quantifier,
.token.keyword {
	color: #f47067;
}

.token.tag,
.token.inserted,
.token.selector,
.token.doctype-tag,
.language-regex .escape {
	color: #8ddb8c;
}

.token.function {
	color: #dcbdfb;
}

.token.attr-value,
.token.string,
.token.char,
.token.regex,
.language-regex,
.token.string-property,
.token.url > .content,
.token.url > .variable {
	color: #96d0ff;
}

.token.builtin,
.token.selector .class,
.token.selector .id,
.token.pseudo-class,
.token.pseudo-element,
.token.attr-name,
.language-css .token.property,
.token.number,
.token.constant,
.token.color,
.token.boolean,
.token.title.important,
.title.important .punctuation,
.language-css .token.function,
.token.code.code-snippet,
.token.doctype,
.token.property-access,
.token.keyword-null,
.token.keyword-this,
.token.char-class,
.token.char-set,
.token.regex .punctuation {
	color: #6cb6ff;
}

.token.comment,
.token.prolog,
.token.cdata {
	color: #768390;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic {
	font-style: italic;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-6 {
	color: #6cb6ff;
}

.token.bracket-level-1,
.token.bracket-level-7 {
	color: #6bc46d;
}

.token.bracket-level-2,
.token.bracket-level-8 {
	color: #daaa3f;
}

.token.bracket-level-3,
.token.bracket-level-9 {
	color: #ff938a;
}

.token.bracket-level-4,
.token.bracket-level-10 {
	color: #fc8dc7;
}

.token.bracket-level-5,
.token.bracket-level-11 {
	color: #dcbdfb;
}

.token.interpolation-punctuation {
	color: #96d0ff;
}

.token.bracket-error {
	color: #768390;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #57ab5a99, inset 0 0 0 9in #57ab5a40;
}

.active-tagname,
.word-matches span {
	box-shadow: inset 0 0 0 1px #636e7b99, inset 0 0 0 9in #636e7b80;
}
